// import Image from "next/image"
import Link from "next/link"
import { Button } from "./Button"
import { removeHtmlTags } from "../utils/utils"
import starIcon from "../assets/starIcon.svg"
import shareIcon from "../assets/shareIcon.svg"
import Image from "next/image"
import { useTranslation } from "react-i18next"
import { ShareModal } from "./ShareModal"
import { useState } from "react"
import { useRouter } from "next/router"
import { ImageFallback } from "./ImageFallback"

//clipShadow border-b-[3px] border-r-[3px] border-premium-yellow absolute -left-2.5 -top-4 rounded-full w-[90px] h-[90px] bg-shadowGradient

const variants = {
    standard: {
        container: "rounded-md  border-[3px] pt-1",
        icon: " h-[66px] w-[66px] -top-2 ",
        border: "absolute -left-2 -top-2.5 rounded-full w-[80px] h-[80px] bg-shadowGradient ",
        label: "text-gray-500",
        button: "mt-1"
    },
    premium: {
        container: "border-[3px] border-premium-yellow clipPolygon rounded-md ",
        icon: "border-[3px] border-premium-yellow h-[70px] w-[70px]",
        border: "",
        label: "pl-4 font-semibold flex gap-2 text-white bg-premium-yellow rounded-full w-32 h-6 flex items-center justify-center",
        button: "bg-premium-yellow"
    }
}

interface ExtensionCardProps {
    icon?: string | React.ReactElement,
    title: string,
    description?: string
    variant: "standard" | "premium"
    href: string
    client_id: string
    dev_user: string
}

export const ExtensionCard = ({ title, description, icon, variant, href, client_id, dev_user }: ExtensionCardProps) => {
    const router = useRouter()
    const medalImg = dev_user.toLowerCase() === "auravant" && "https://cdn-icons-png.flaticon.com/256/1534/1534214.png"
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    return <article className={`w-60 lg:w-72 relative rounded-tl-[50px] bg-white rounded-md shadow-around`}>
        <header className="absolute">
            <div className="relative w-[68px] h-[68px]">
                <div className={`bg-white rounded-full flex items-center justify-center absolute -top-2 -left-1 shadow-icon z-20 ${variants[variant].icon}`}>
                    {typeof icon === "string" ? <ImageFallback className="rounded-full" src={icon} width={50} height={50} alt={title + " icon"} /> : icon}
                </div>
                <div className={`${variants[variant].border}`} />
            </div>
        </header>
        <div className={`${variants[variant].container}`}>
            <div className="mt-2 relative " >
                <h1 className="font-semibold pl-20 overflow-hidden text-ellipsis h-6">{title}</h1>
                <div className={`${variants[variant].label} mt-1  ml-[78px] flex`}>
                    <span className=" text-xs flex ">{variant === "standard" ? t("extension.gratuita").toUpperCase() : t("extension.premium").toUpperCase()}
                        {variant === "premium" && <Image src={starIcon} width={16} height={16} alt="star-icon" className=" ml-2" priority />}
                    </span>
                    <span className="absolute right-0 pr-2 lg:pr-4">
                        <button onClick={() => setIsOpen(true)}>
                            <Image src={shareIcon} width={16} height={16} alt="share-icon" priority />
                        </button>
                        <ShareModal href={client_id} isOpen={isOpen} onClose={() => setIsOpen(false)} title={title} />
                    </span>
                </div>
            </div>
            <div className=" flex justify-center pr-8  md:pr-12">
                <div className={`${!medalImg && "mr-12"} w-16 relative  pt-1 flex pl-3`}>
                    {medalImg && <Image src={medalImg} alt="dev-medal" className="absolute -left-3" height={20} width={20} />}
                    <span className="text-xs my-0.5 whitespace-nowrap italic">{dev_user}</span>
                </div>
                {/* Agregar medalla de desarrollador, si es auravant en dorada, si es externo en azul */}
            </div>
            <section className={`pl-2 pb-2 text-xs relative`}>

                <p className="w-48 lg:w-64 leading-5 text-xs h-[3.5rem] text-ellipsis overflow-hidden">{removeHtmlTags(description ?? "")}</p>
            </section>
            <footer className="flex justify-center pb-2">
                <Button variant="primary" className={`shadow-lg w-52 lg:w-64 flex justify-center h-10 items-center  ${variants[variant].button}`}>
                    <Link href={`/${router.query.locale.toString()}/extension/${href}`} className="w-64 whitespace-nowrap  rounded-md py-2">{t("btn.default").toUpperCase()}</Link>
                </Button>
            </footer>
        </div>
    </article >
}